/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerPatchMutationRequest,
  TelegramProductsModeratorControllerPatchMutationResponse,
  TelegramProductsModeratorControllerPatchPathParams,
  TelegramProductsModeratorControllerPatch401,
  TelegramProductsModeratorControllerPatch404,
} from '../../types/TelegramProductsModeratorControllerPatch.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorPatch } from '../../methods/telegramProductsModeratorPatch.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorPatchMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/:id' }] as const;

export type TelegramProductsModeratorPatchMutationKey = ReturnType<typeof telegramProductsModeratorPatchMutationKey>;

/**
 * {@link /api/moderator/telegram/products/:id}
 */
export function useTelegramProductsModeratorPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerPatchMutationResponse,
      ResponseErrorConfig<TelegramProductsModeratorControllerPatch401 | TelegramProductsModeratorControllerPatch404>,
      {
        id: TelegramProductsModeratorControllerPatchPathParams['id'];
        data?: TelegramProductsModeratorControllerPatchMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsModeratorControllerPatchMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorPatchMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerPatchMutationResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerPatch401 | TelegramProductsModeratorControllerPatch404>,
    {
      id: TelegramProductsModeratorControllerPatchPathParams['id'];
      data?: TelegramProductsModeratorControllerPatchMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return telegramProductsModeratorPatch(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
